module.exports = __webpack_public_path__ + "img/PL08734.3d7f0cbd.png";